// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1tu7r","list":"styles_list__3Xe4M"};